import * as types from './actionTypes';
import PrivateAPIResource from "../services/PrivateAPIResource";

export function loadKeywordsPacksSuccess(keywordsPacks) {
    return {type: types.LOAD_KEYWORDS_PACKS_SUCCESS, keywordsPacks};
}

export function createKeywordsPackSuccess(keywordsPack) {
    return {type: types.CREATE_KEYWORDS_PACK_SUCCESS, keywordsPack};
}

export function getKeywordsPackSuccess(keywordsPack) {
    return {type: types.GET_KEYWORDS_PACK_SUCCESS, keywordsPack};
}

export function updateKeywordsPackSuccess(keywordsPack) {
    return {type: types.UPDATE_KEYWORDS_PACK_SUCCESS, keywordsPack};
}

export function deleteKeywordsPackSuccess(id) {
    return {type: types.DELETE_KEYWORDS_PACK_SUCCESS, id};
}

export function resetKeywordsPack() {
    return { type: types.RESET_KEYWORDS_PACK };
}

export function getKeywordsPack(id) {
    return function (dispatch) {
        return PrivateAPIResource.get('keywords-packs/' + id).then(keywordsPack => {
            dispatch(getKeywordsPackSuccess(keywordsPack))
        }).catch(error => {
            throw error;
        });
    }
}

export function loadKeywordsPacks(page, sortParams) {
    return function (dispatch) {
        return PrivateAPIResource.all('keywords-packs', sortParams).then(keywordsPacks => {
            dispatch(loadKeywordsPacksSuccess(keywordsPacks))
        }).catch(error => {
            throw error;
        });
    }
}

export function saveKeywordsPack(keywordsPack) {
    return function (dispatch, getState) {
        return PrivateAPIResource.create('keywords-packs/create', keywordsPack).then(keywordsPack => {
            dispatch(createKeywordsPackSuccess(keywordsPack));
        }).catch(error => {
            throw error;
        })
    }
}

export function updateKeywordsPack(keywordsPack, id) {
    return function (dispatch, getState) {
        return PrivateAPIResource.update('keywords-packs/update', id, keywordsPack).then(keywordsPack => {
            dispatch(updateKeywordsPackSuccess(keywordsPack));
        }).catch(error => {
            throw error;
        })
    }
}

export function deleteKeywordsPack(id) {
    return function (dispatch) {
        return PrivateAPIResource.remove('keywords-packs/remove', id).then(() => {
            dispatch(deleteKeywordsPackSuccess(id));
        }).catch(error => {
            throw error;
        });
    }
}



// WEBPACK FOOTER //
// ./web/src/actions/keywordsPackActions.js